import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBDgv5cBPbo63-HBILPZAGmRk5UXRcra2U",
  authDomain: "chattu-e10c1.firebaseapp.com",
  projectId: "chattu-e10c1",
  storageBucket: "chattu-e10c1.firebasestorage.app",
  messagingSenderId: "257415466297",
  appId: "1:257415466297:web:b2348b166a80ce5abface8"
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
